import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import VConsole from 'vconsole'; // 重新启用vConsole导入
// 直接使用环境变量
const isStaging = () => process.env.NODE_ENV === 'staging';
const isDevelopment = () => process.env.NODE_ENV === 'development';
// 生产环境控制台配置 - 已启用控制台输出
// if (process.env.NODE_ENV === 'production') {
//   const noop = () => {};
//   // 仅保留 warn/error，视需要可以把 warn 也降级
//   console.log = noop; // eslint-disable-line no-console
//   console.debug = noop; // eslint-disable-line no-console
//   // console.warn = noop; // 若希望强力降噪，取消注释
// }

// 构建时环境变量调试 - 仅在非生产环境显示
if (process.env.NODE_ENV !== 'production') {
  console.log('🔧 构建时环境变量检查 🔧');
  console.log('REACT_APP_ENV:', process.env.REACT_APP_ENV);
  console.log('NODE_ENV:', process.env.NODE_ENV);
  console.log('构建时间:', new Date().toISOString());
}

// vConsole 调试工具 - 仅在测试和开发环境启用
// 生产环境关闭vConsole
if (isStaging() || isDevelopment()) {
  new VConsole(); // 仅在测试和开发环境启用vConsole
}

// 过滤第三方脚本错误（可选）
const originalError = console.error;
console.error = (...args) => {
  const message = args[0];
  if (typeof message === 'string' && 
      (message.includes('content_script.js') || 
       message.includes('MutationObserver') ||
       message.includes('classList'))) {
    // 忽略第三方脚本错误
    return;
  }
  originalError.apply(console, args);
};

// 检测是否为测试环境部署
const isTestFormDeployment = window.location.pathname.startsWith('/microform-test') || 
                             process.env.PUBLIC_URL === '/microform-test';

// 调试信息 - 仅在非生产环境显示
if (process.env.NODE_ENV !== 'production') {
  console.log('🔍 路径检测调试信息:');
  console.log('当前路径:', window.location.pathname);
  console.log('PUBLIC_URL:', process.env.PUBLIC_URL);
  console.log('是否测试环境:', isTestFormDeployment);
  console.log('BrowserRouter basename:', isTestFormDeployment ? '/microform-test' : '');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter basename={isTestFormDeployment ? '/microform-test' : ''}>
        <App />
    </BrowserRouter>
);
